// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"474":"7e5b7c0b","575":"7e5b7c0b"}[chunkId] + ".chunk.css";
};